export default __webpack_public_path__ + "static/media/photo--lg--25.0bc6c676.jpg";